import type { BaseQueryFn } from '@reduxjs/toolkit/query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import axiosClient from '../axios-client' // <-- your configured instance

export const axiosBaseQuery =
  ({ baseUrl = '' }: { baseUrl?: string } = {}): BaseQueryFn<
    { url: string; method?: AxiosRequestConfig['method']; data?: unknown; params?: unknown; headers?: AxiosRequestConfig['headers'] },
    unknown,
    { status?: number; data?: unknown }
  > =>
  async ({ url, method = 'GET', data, params, headers }) => {
    try {
      const res = await axiosClient({ url: baseUrl + url, method, data, params, headers })
      return { data: res.data }
    } catch (e) {
      const err = e as AxiosError
      return { error: { status: err.response?.status, data: err.response?.data ?? err.message } }
    }
  }
